export default "__VITE_ASSET__cc3f19f0__"